<template>
    <div class="designeroption" data-designer-component-id="notes">
    <h3>{{ title }}</h3>
        <div class="stylesoption">
            <div class="form-group">
                <textarea v-model="localTarget" class="form-control" id="notes" rows="10" :placeholder="placeholder"  dusk="door_notes"></textarea>
                <span id="remain" class="txt-sm">{{ limit_input }}</span> characters remaining
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { nextTick } from 'vue';

    export default {
        emits: ['update:target'],
        props: {
            title: {
                default(){
                    return 'Enter Any Notes For This Door';
                }
            },
            target: {
                default: ''
            },
            max_char: {
                default: 255
            },
            placeholder: {
              default: ''
            },
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            limit_input(){
                if (this.localTarget == null) {
                    return 0;
                }
                if (this.localTarget.length >= this.max_char) {
                    $('#notes').val($('#notes').val().substring(0, this.max_char));
                }
                if (this.max_char - this.localTarget.length < 1) {
                    return 0;
                }
                return this.max_char - this.localTarget.length;
            },
            cache_key(){
                return '_';
            },
        },
      watch: {
        'localTarget': {
          handler: window._.debounce(function () {
            nextTick(() => {
              if (this.passed_filter && this.url) {
                this.localTarget = this.localTarget.replace(/[^a-zA-Z0-9.]+/g," ");
              }
            });
          }, 50),
        }
      },
    }
</script>
